import * as React from 'react';
import styles from './select-all.scss';

interface SelectAllProps {
  textSelectAll: string;
  textClearAll: string;
  onChange: (enabled: boolean) => void;
}

export class SelectAll extends React.Component<SelectAllProps> {
  private selectAll = () => this.props.onChange(true);
  private clearAll = () => this.props.onChange(false);

  public render(): JSX.Element {
    return (
      <div className={styles.wrapper}>
        <button onClick={this.selectAll}>
          {this.props.textSelectAll}
        </button> | <button onClick={this.clearAll}>
          {this.props.textClearAll}
        </button>
      </div>
    );
  }
}
